import HttpService from "./HttpService";

class EmpresaService extends HttpService {
  getCompanies() {
    return this.get(`/companies`).then((response) => response.data);
  }

  getEmpresaById(id) {
    return this.get(`/companies/${id}`);
  }

  createCompany(data) {
    const { nome, cnpj_cpf, fone, email } = data;
    const createCompanyDTO = {
      nome,
      cnpj: cnpj_cpf,
      telefone: fone,
      email,
    };
    return this.post("/companies", createCompanyDTO);
  }

  updateCompany(id, data) {
    return this.put(`/companies/${id}`, data);
  }

  deleteEmpresa(id) {
    return this.delete(`/companies/${id}`);
  }

  toInactiveCompany(uuid) {
    return this.put(`/companies/${uuid}/inactive`);
  }

  toActiveCompany(uuid) {
    return this.put(`/companies/${uuid}/activate`);
  }

  async verifyCode(codigo) {
    const response = await this.get(`/companies/code/${codigo}`);
    return response;
  }

  async recenteRecords({ startDate, endDate, limit }) {
    const response = await this.get("/companies/recent-records", {
      params: { startDate, endDate, limit },
    });
    return response.data;
  }

  async recenteRecordsMarkAsViewed(data) {
    const response = await this.put("/companies/recent-records/viewed", data);
    return response.data;
  }
}

export default EmpresaService;
